import { ElementRef, QueryList } from '@angular/core';
import { PendingInfluencerChannel, PendingInfluencerChannelStatus } from '../../../../models/influencer/pending-influencer';
import { InfluencerService } from '../../../services/influencer/influencer.service';
import { PlaceholderVisibilityService } from '../../../services/placeholder-visibility/placeholder-visibility.service';
import { AchooPopupComponent } from '../../../core/achoo-popup/achoo-popup.component';
import { ModalService } from '../../../services/modal/modal.service';
import { FormBuilder } from '@angular/forms';
import { NewInfluencerChanel } from '../../../../models/influencer/new-influencer';
import { Observable } from 'rxjs/Observable';
import { TranslateService } from '@ngx-translate/core';
import { ReferenceDataService } from '../../../services/reference-data/reference-data.service';
import { CommonConstant, platformIconPath } from '../../../app.constants';
import { ValidationHandlerService } from '../../../core/validation-handler.service';
import { StringUtils } from '../../../utils/string.utils';
import { Subject } from 'rxjs/Subject';
import { UpdateChannelRequest } from '../../../../models/influencer-setting';
import { debounceTime, tap, filter } from 'rxjs/operators';
import { DismissInfluencerPopupComponent } from './dismiss-influencer-popup/dismiss-influencer-popup.component';
import { AchooFilterBoxComponent } from '../../../core/achoo-filter-box/achoo-filter-box.component';
import { WebUtils } from '../../../utils/web.utils';
var InfluencerReviewComponent = /** @class */ (function () {
    function InfluencerReviewComponent(influencerService, modalService, formBuilder, translate, referenceDataService, validator, placeholderService) {
        this.influencerService = influencerService;
        this.modalService = modalService;
        this.formBuilder = formBuilder;
        this.translate = translate;
        this.referenceDataService = referenceDataService;
        this.validator = validator;
        this.placeholderService = placeholderService;
        this.influencerReviewLoading = 'InfluencerReviewLoading';
        this.isDismissing = false;
        this.newChannelIndex = 0;
        this.isLoading = false;
        this.hasFieldErrors = false;
        this.handleChanged = new Subject();
        this.fieldMapping = new Map();
        this.activeTabIndex = 1;
    }
    InfluencerReviewComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.initForm();
        this.initReferenceData();
        this.pendingInfluencerSubscription = this.influencerService.activePendingInfluencer.subscribe(function (data) {
            if (data) {
                _this.pendingInfluencer = data;
                _this.pendingInfluencer.channels.forEach(function (channel) { return _this.updateChannelLinkInfo(channel); });
                _this.pendingInfluencerForm.patchValue({
                    name: _this.pendingInfluencer.name,
                    phone: _this.pendingInfluencer.phone,
                    email: _this.pendingInfluencer.email
                });
                _this.updateFieldMapping(1);
            }
        });
        this.loadPendingInfluencer();
        this.validationSubscription = this.validator.validationErrorsSubject.subscribe(function (errors) {
            var isMissingName = errors.filter(function (err) { return err.name === 'pendingInfluencer.name'; }).length > 0;
            if (isMissingName) {
                _this.pendingInfluencerForm.controls['name'].setErrors({ 'incorrect': true });
            }
            else {
                _this.pendingInfluencerForm.controls['name'].setErrors(null);
            }
        });
        this.handleChangedSubscription = this.handleChanged.pipe(tap(function (channel) { return _this.resetChannelLinkInfo(channel); }), debounceTime(700), filter(function (channel) { return channel.platform_id !== undefined && channel.handle !== undefined; })).subscribe(function (channel) {
            _this.precheckChannel(channel, _this.pendingInfluencer.id);
        });
    };
    InfluencerReviewComponent.prototype.ngOnDestroy = function () {
        if (this.pendingInfluencerSubscription) {
            this.pendingInfluencerSubscription.unsubscribe();
        }
        if (this.validationSubscription) {
            this.validationSubscription.unsubscribe();
        }
        if (this.handleChangedSubscription) {
            this.handleChangedSubscription.unsubscribe();
        }
    };
    InfluencerReviewComponent.prototype.initForm = function () {
        this.pendingInfluencerForm = this.formBuilder.group({
            name: [null],
            email: [null],
            phone: [null]
        });
    };
    InfluencerReviewComponent.prototype.initReferenceData = function () {
        this.countries = this.referenceDataService.countries;
        this.languages = this.referenceDataService.languages;
        this.genders = CommonConstant.GENDERS;
        this.platforms = this.referenceDataService.platforms;
    };
    InfluencerReviewComponent.prototype.handleKeyDown = function (event) {
        if (event.keyCode === 13) {
            this.handleEnterEvent();
            event.preventDefault();
        }
        else if (event.keyCode === 9) {
            this.handleTabEvent();
            event.preventDefault();
        }
    };
    InfluencerReviewComponent.prototype.setActiveField = function (index) {
        this.activeTabIndex = index;
    };
    InfluencerReviewComponent.prototype.handleEnterEvent = function () {
        var activeField = this.fieldMapping.get(this.activeTabIndex - 1);
        if (this.dismissInfluencerPopupRef) {
            if (this.dismissInfluencerPopupContent.canSubmit) {
                this.confirmDismissInfluencer({
                    reason: this.dismissInfluencerPopupContent.selectedDismissReason
                });
            }
        }
        else if (this.confirmationPopupRef) {
            this.onAcceptToSubmitInfluencer();
        }
        else if (activeField && activeField.nativeElement && activeField.nativeElement instanceof HTMLButtonElement) {
            activeField.nativeElement.click();
        }
        else {
            this.getNextInfluencer();
        }
    };
    InfluencerReviewComponent.prototype.handleTabEvent = function () {
        var activeField = this.fieldMapping.get(this.activeTabIndex);
        if (!activeField) {
            this.activeTabIndex = 1;
            return;
        }
        if (activeField instanceof AchooFilterBoxComponent) {
            if (activeField.ngSelect.isFocused) {
                activeField.ngSelect.close();
            }
            else {
                activeField.ngSelect.open();
            }
        }
        else if (activeField instanceof HTMLInputElement) {
            activeField.focus();
        }
        else {
            activeField.nativeElement.focus();
        }
        this.activeTabIndex = this.activeTabIndex + 1;
        if (this.activeTabIndex > this.fieldMapping.size) {
            this.activeTabIndex = 1;
        }
    };
    InfluencerReviewComponent.prototype.showLoading = function () {
        this.placeholderService.show(this.influencerReviewLoading);
        this.isLoading = true;
    };
    InfluencerReviewComponent.prototype.hideLoading = function () {
        this.placeholderService.hide(this.influencerReviewLoading);
        this.isLoading = false;
    };
    InfluencerReviewComponent.prototype.handleUpdatePendingInfluencerError = function () {
        this.modalService.open(this.errorWhenLoadingPendingInfluencer, null, true);
        if (this.processingPendingInfluencer) {
            this.influencerService.updatePendingInfluencerError(this.processingPendingInfluencer);
        }
    };
    InfluencerReviewComponent.prototype.handleLoadPendingInfluencerError = function () {
        this.errorMessage = this.translate.instant('pending_influencer.load_influencer_error');
        this.modalService.open(this.errorWhenLoadingPendingInfluencer, null, true);
        this.hideLoading();
    };
    InfluencerReviewComponent.prototype.onSubmit = function () {
        var _this = this;
        this.confirmationPopupRef = this.modalService.openInCenter(this.submitInfluencerConfirmation, function () {
            _this.confirmationPopupRef = null;
        });
    };
    InfluencerReviewComponent.prototype.clickNext = function (btn) {
        btn.blur();
        this.getNextInfluencer();
    };
    InfluencerReviewComponent.prototype.updateAndNext = function () {
        var _this = this;
        var validationErrors = this.validateInfluencerData(this.pendingInfluencer);
        if (validationErrors.length > 0) {
            this.hasFieldErrors = true;
            return;
        }
        if (this.influencerService.isLastPendingInfluencer(this.pendingInfluencer)) {
            this.updatePendingInfluencer(this.pendingInfluencer, function () {
                _this.loadPendingInfluencer();
                _this.processingPendingInfluencer = null;
            });
        }
        else {
            this.updatePendingInfluencer(this.pendingInfluencer, function () {
                _this.processingPendingInfluencer = null;
            });
            this.influencerService.getNextPendingInfluencer(this.hideLoading.bind(this), this.getNextInfluencerError.bind(this));
        }
    };
    InfluencerReviewComponent.prototype.updatePendingInfluencer = function (pendingInfluencer, successCallback) {
        var _this = this;
        this.processingPendingInfluencer = pendingInfluencer;
        this.hasFieldErrors = false;
        var influencerChannelObservers = [];
        var existingChannelIds = pendingInfluencer.channels.map(function (ic) { return ic.id; });
        pendingInfluencer.channels.forEach(function (channel) {
            if (channel.status === PendingInfluencerChannelStatus.NEW) {
                var newChannel = new NewInfluencerChanel(channel.platform_id);
                newChannel.handle = channel.handle;
                newChannel.influencerId = _this.pendingInfluencer.id;
                influencerChannelObservers.push(_this.influencerService.addInfluencerChannel(pendingInfluencer.id, newChannel).map(function (nc) { return nc.data; }));
            }
            else if (channel.handle_updated) {
                var updatedChannel = _this.buildChannelUpdateDataForAPI(channel, _this.pendingInfluencer.id);
                influencerChannelObservers.push(_this.influencerService.updateInfluencerChannel(channel.id, updatedChannel));
            }
        });
        pendingInfluencer.is_active = 1;
        pendingInfluencer.pending_completed = true;
        pendingInfluencer.dismiss_reason = null;
        if (influencerChannelObservers.length > 0) {
            Observable.forkJoin(influencerChannelObservers).subscribe(function (res) {
                var newChannelIds = res.filter(function (c) { return existingChannelIds.indexOf(c.id) < 0; }).map(function (nc) { return nc.id; });
                var updatedChannelIds = res.filter(function (c) { return existingChannelIds.indexOf(c.id) >= 0; }).map(function (nc) { return nc.id; });
                _this.completePendingInfluencer(pendingInfluencer, newChannelIds, updatedChannelIds, successCallback);
            }, function (err) {
                _this.errorMessage = _this.translate.instant('pending_influencer.add_new_channel_error');
                _this.handleUpdatePendingInfluencerError();
            });
        }
        else {
            this.completePendingInfluencer(pendingInfluencer, [], [], successCallback);
        }
    };
    InfluencerReviewComponent.prototype.completePendingInfluencer = function (pendingInfluencer, newChannelIds, updatedChannelIds, successCallback) {
        var _this = this;
        this.influencerService.updatePendingInfluencer(pendingInfluencer, newChannelIds, updatedChannelIds).subscribe(function (res) {
            _this.successCompletedInfluencer = _this.processingPendingInfluencer.id;
            _this.modalService.open(_this.pendingInfluencerSuccessNotification, null, true);
            var completedInfluencer = res.data.pending_influencer;
            var normalizedCompletedInfluencer = Object.assign({}, completedInfluencer, {
                languages: completedInfluencer.languages && completedInfluencer.languages.length > 0 ? completedInfluencer.languages[0] : null
            });
            _this.influencerService.updatePendingInfluencerList(normalizedCompletedInfluencer);
            if (successCallback) {
                successCallback();
            }
        }, function (error) {
            if (error.status !== 404) {
                _this.errorMessage = _this.translate.instant('pending_influencer.update_influencer_error');
                _this.handleUpdatePendingInfluencerError();
            }
            else if (successCallback) {
                successCallback();
            }
        });
    };
    Object.defineProperty(InfluencerReviewComponent.prototype, "totalPendingInfluencer", {
        get: function () {
            return this.influencerService.getTotalPendingInfluencer();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerReviewComponent.prototype, "numberOfPendingInfluencersInCampaign", {
        get: function () {
            return this.influencerService.getNumberOfPendingInfluencersInCampaign();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InfluencerReviewComponent.prototype, "hasErrorWithNameInput", {
        get: function () {
            var name = this.pendingInfluencerForm.get('name');
            return name.invalid && (name.dirty || name.touched) && name.errors.required;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerReviewComponent.prototype.loadPendingInfluencer = function () {
        this.showLoading();
        this.influencerService.loadPendingInfluencerList(this.hideLoading.bind(this), this.handleLoadPendingInfluencerError.bind(this));
    };
    InfluencerReviewComponent.prototype.addNewChannel = function () {
        var newChannel = new PendingInfluencerChannel();
        newChannel.status = PendingInfluencerChannelStatus.NEW;
        newChannel.index = this.newChannelIndex;
        this.pendingInfluencer.channels.push(newChannel);
        this.newChannelIndex = this.newChannelIndex + 1;
        this.updateFieldMapping(6 + (this.pendingInfluencer.channels.length - 1) * 2 + 1);
    };
    InfluencerReviewComponent.prototype.deleteChannel = function (channel) {
        var _this = this;
        if (channel.status === PendingInfluencerChannelStatus.NEW) {
            var deleteIdx = this.pendingInfluencer.channels.findIndex(function (pc) { return pc.index === channel.index; });
            this.pendingInfluencer.channels.splice(deleteIdx, 1);
            this.updateFieldMapping(1);
        }
        else {
            this.channelToDelete = channel;
            this.modalService.openInCenter(this.deleteChannelWarning, function () {
                _this.channelToDelete = null;
            });
        }
    };
    InfluencerReviewComponent.prototype.updateFieldMapping = function (index) {
        var _this = this;
        setTimeout(function () {
            _this.buildFieldMapping();
            _this.activeTabIndex = index;
        }, 100);
    };
    InfluencerReviewComponent.prototype.buildFieldMapping = function () {
        var _this = this;
        this.fieldMapping = new Map();
        this.fieldMapping.set(1, this.countrySelection);
        this.fieldMapping.set(2, this.languageSelection);
        this.fieldMapping.set(3, this.genderSelection);
        this.fieldMapping.set(4, document.getElementById('ir_field_4'));
        this.fieldMapping.set(5, document.getElementById('ir_field_5'));
        this.fieldMapping.set(6, document.getElementById('ir_field_6'));
        this.pendingInfluencer.channels.forEach(function (channel, idx) {
            var tabIndex = 6 + idx * 2 + 1;
            var platformField = _this.dropdownList.find(function (c) { return c.id === "ir_field_" + tabIndex; });
            if (platformField) {
                _this.fieldMapping.set(tabIndex, platformField);
            }
            var handleField = document.getElementById("ir_field_" + (tabIndex + 1));
            if (handleField) {
                _this.fieldMapping.set(tabIndex + 1, handleField);
            }
        });
        var addChannelButtonTabIndex = 6 + this.pendingInfluencer.channels.length * 2 + 1;
        this.fieldMapping.set(addChannelButtonTabIndex, this.addNewChannelBtn);
        this.fieldMapping.set(addChannelButtonTabIndex + 1, this.dismissInfluencerButton);
        this.fieldMapping.set(addChannelButtonTabIndex + 2, this.backButton);
        this.fieldMapping.set(addChannelButtonTabIndex + 3, this.nextButton);
    };
    InfluencerReviewComponent.prototype.closeDeleteChannelWarningPopup = function () {
        this.modalService.close();
        this.channelToDelete = null;
    };
    InfluencerReviewComponent.prototype.onAcceptToDeleteChannel = function () {
        var _this = this;
        this.modalService.close();
        if (!this.channelToDelete) {
            return;
        }
        var deleteIdx = this.pendingInfluencer.channels.findIndex(function (pc) { return pc.id === _this.channelToDelete.id; });
        this.pendingInfluencer.channels.splice(deleteIdx, 1);
        this.updateFieldMapping(1);
        this.influencerService.deleteInfluencerChannel(this.channelToDelete.id).subscribe(function (res) {
            _this.channelToDelete = null;
        }, function (err) {
            _this.errorMessage = _this.translate.instant('pending_influencer.delete_channel_error');
            _this.modalService.open(_this.errorWhenLoadingPendingInfluencer, function () {
                _this.errorMessage = null;
            }, true);
            // revert the change before
            _this.pendingInfluencer.channels.splice(deleteIdx, 0, _this.channelToDelete);
            _this.updateFieldMapping(1);
        });
    };
    InfluencerReviewComponent.prototype.onAcceptToSubmitInfluencer = function () {
        this.closeNotification();
        this.updateAndNext();
    };
    InfluencerReviewComponent.prototype.trackChannelFn = function (index, channel) {
        return index;
    };
    InfluencerReviewComponent.prototype.getPreviousInfluencer = function () {
        this.modalService.close();
        this.showLoading();
        this.influencerService.getPreviousPendingInfluencer(this.hideLoading.bind(this), this.showErrorMessage.bind(this, this.translate.instant('pending_influencer.get_previous_influencer_error')));
    };
    InfluencerReviewComponent.prototype.dismissInfluencer = function () {
        var _this = this;
        this.dismissInfluencerPopupRef = this.modalService.openInCenter(this.dismissInfluencerPopup, this.beforeCloseDismissPopup.bind(this), 'dismiss-influencer-popup');
        setTimeout(function () {
            _this.dismissInfluencerPopupContent.dismissReason.ngSelect.open();
            _this.dismissInfluencerButton.nativeElement.blur();
        }, 50);
    };
    InfluencerReviewComponent.prototype.beforeCloseDismissPopup = function () {
        if (this.dismissInfluencerPopupContent) {
            this.dismissInfluencerPopupContent.selectedDismissReason = null;
            this.dismissInfluencerPopupContent.canSubmit = false;
        }
        this.dismissInfluencerPopupRef = null;
    };
    InfluencerReviewComponent.prototype.confirmDismissInfluencer = function (evt) {
        var _this = this;
        this.closeDismissPopup();
        this.pendingInfluencer.dismiss_reason = evt.reason;
        this.pendingInfluencer.pending_completed = true;
        this.pendingInfluencer.is_active = 2;
        this.isDismissing = true;
        this.influencerService.updatePendingInfluencer(this.pendingInfluencer, [], []).subscribe(function (res) {
            _this.isDismissing = false;
            _this.successCompletedInfluencer = _this.pendingInfluencer.id;
            _this.modalService.open(_this.pendingInfluencerSuccessNotification, null, true);
            _this.influencerService.getNextPendingInfluencer(_this.hideLoading.bind(_this), _this.getNextInfluencerError.bind(_this));
            if (_this.dismissInfluencerPopupContent) {
                _this.dismissInfluencerPopupContent.selectedDismissReason = null;
                _this.dismissInfluencerPopupContent.canSubmit = false;
            }
        }, function (error) {
            _this.errorMessage = _this.translate.instant('pending_influencer.update_influencer_error');
            _this.modalService.open(_this.errorWhenLoadingPendingInfluencer, null, true);
            _this.isDismissing = false;
        });
    };
    InfluencerReviewComponent.prototype.closeDismissPopup = function () {
        this.beforeCloseDismissPopup();
        this.modalService.close();
    };
    InfluencerReviewComponent.prototype.showErrorMessage = function (errorMessage) {
        var _this = this;
        this.hideLoading();
        this.errorMessage = errorMessage;
        this.modalService.open(this.errorWhenLoadingPendingInfluencer, function () {
            _this.errorMessage = null;
        }, true);
    };
    InfluencerReviewComponent.prototype.getNextInfluencer = function () {
        var validationErrors = this.validateInfluencerData(this.pendingInfluencer);
        if (validationErrors.length > 0) {
            this.hasFieldErrors = true;
            return;
        }
        this.onSubmit();
    };
    InfluencerReviewComponent.prototype.afterLoading = function () {
        this.isLoading = false;
    };
    InfluencerReviewComponent.prototype.getNextInfluencerError = function () {
        var _this = this;
        this.errorMessage = this.translate.instant('pending_influencer.get_next_influencer_error');
        this.modalService.open(this.errorWhenLoadingPendingInfluencer, function () {
            _this.errorMessage = null;
        }, true);
        this.isLoading = false;
    };
    InfluencerReviewComponent.prototype.validateInfluencerData = function (influencer) {
        var errors = [];
        if (!influencer.name || StringUtils.trim(influencer.name) === '') {
            errors.push({ name: 'pendingInfluencer.name', message: null });
        }
        if (!influencer.country) {
            errors.push({ name: 'pendingInfluencer.country', message: null });
        }
        if (!influencer.languages) {
            errors.push({ name: 'pendingInfluencer.languages', message: null });
        }
        if (influencer.gender === null) {
            errors.push({ name: 'pendingInfluencer.gender', message: null });
        }
        influencer.channels.forEach(function (c) {
            if (c.handle_error || !c.handle || c.handle === '') {
                var errorKey = c.id > 0 ? "pendingInfluencerChannel" + c.id + ".handle" : "pendingInfluencerChannel" + c.index + ".handle";
                errors.push({ name: errorKey, message: null });
            }
            if (c.platform_id <= 0) {
                var errorKey = c.id > 0 ? "pendingInfluencerChannel" + c.id + ".platform" : "pendingInfluencerChannel" + c.index + ".platform";
                errors.push({ name: errorKey, message: null });
            }
        });
        return errors;
    };
    Object.defineProperty(InfluencerReviewComponent.prototype, "isDisableSaveBtn", {
        get: function () {
            var isMissingNameField = this.pendingInfluencerForm.controls['name'].invalid && this.pendingInfluencerForm.controls['name'].touched;
            return isMissingNameField || !this.pendingInfluencer.country
                || !this.pendingInfluencer.languages
                || !this.pendingInfluencer.gender === null
                || this.isLoading;
        },
        enumerable: true,
        configurable: true
    });
    InfluencerReviewComponent.prototype.closeNotification = function () {
        this.modalService.close();
        this.confirmationPopupRef = null;
    };
    InfluencerReviewComponent.prototype.getSourceId = function (channel) {
        return this.hasSourceIdError(channel) ? channel.source_id_error : channel.source_id;
    };
    InfluencerReviewComponent.prototype.hasSourceIdError = function (channel) {
        return channel.source_id_error && channel.source_id_error != null;
    };
    InfluencerReviewComponent.prototype.changeHandle = function (handle, channel) {
        this.handleChanged.next(channel);
    };
    InfluencerReviewComponent.prototype.getOfficialLanguage = function (evt) {
        var _this = this;
        this.referenceDataService.getLanguageByCountry(evt.id).subscribe(function (res) {
            _this.pendingInfluencer.languages = res.id;
        });
    };
    InfluencerReviewComponent.prototype.precheckChannel = function (channel, influencerId) {
        var _this = this;
        var channelData = this.buildChannelUpdateDataForAPI(channel, influencerId);
        this.influencerService.precheckInfluencerChannel(channel.id, channelData).subscribe(function (res) {
            channel.handle_updated = true;
            channel.handle_error = null;
            _this.updateChannelLinkInfo(channel);
            _this.modalService.close();
        }, function (error) {
            channel.handle_error = _this.translate.instant('pending_influencer.existed_handle');
            _this.showErrorMessage(channel.handle_error);
        });
    };
    InfluencerReviewComponent.prototype.buildChannelUpdateDataForAPI = function (channel, influencerId) {
        var channelData = new UpdateChannelRequest();
        channelData.id = channel.id;
        channelData.handle = channel.handle;
        channelData.type = channel.type;
        channelData.platform_id = channel.platform_id;
        channelData.blog_id = influencerId;
        if (channel.platform_id === platformIconPath.youtube.id) {
            channelData.youtubeType = CommonConstant.YOUTUBE_CHANNEL;
        }
        return channelData;
    };
    InfluencerReviewComponent.prototype.updateChannelLink = function (channel) {
        this.handleChanged.next(channel);
    };
    InfluencerReviewComponent.prototype.updateChannelLinkInfo = function (channel) {
        var link = null;
        var platformName = null;
        var platform = this.platforms.find(function (p) { return p.id === channel.platform_id; });
        if (platform) {
            platformName = platform.name.toLowerCase();
            link = WebUtils.buildSocialChannelLink({ name: platform.name, domain: platform.domain }, channel.handle);
        }
        channel.link = link;
        channel.platformName = platformName;
    };
    InfluencerReviewComponent.prototype.resetChannelLinkInfo = function (channel) {
        channel.link = null;
        channel.platformName = null;
    };
    return InfluencerReviewComponent;
}());
export { InfluencerReviewComponent };



// WEBPACK FOOTER //
// ./src/app/main/admin/influencer-review/influencer-review.component.ts.pre-build-optimizer.js